<app-navbar-style-one></app-navbar-style-one>

<div class="container-fluid mt-4 product-page">
    <div class="row">
        <div class="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
            <div>
                <div class="ms-5">
                    <h2 class="productName">{{selectedProduct.name}}</h2>
                    <p class="mt-4 mb-0">{{selectedProduct.components}}</p>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 text-center">
            <img src="{{selectedProduct.avatar}}" class="productImage" width="300" height="300" alt="{{selectedProduct.name}}">
        </div>
    </div>
    <div class="container">
        <div class="row mt-2">
            <div class="col-lg-6 mt-3">
                <!-- Dynamic Size Selection -->
                <div class="list-group mb-4 sizeDiv h-100" *ngIf="selectedProduct.types?.length">
                    <h5 class="fw-bold mb-1">Size <label *ngIf="selectedProduct.offer" style="font-size: 15px;" class="offer-badge">{{ getOfferText(selectedProduct.offer) }}</label></h5>
                    <label class="list-group-item d-flex justify-content-between align-items-center"
                        *ngFor="let type of selectedProduct.types">
                        <span>
                            <span>{{type.name}}</span>
                            <span *ngIf="selectedProduct.offer">
                                <span class="text-muted text-decoration-line-through me-2 ms-2">
                                    {{type.price | currency}}
                                </span>
                                <span class="text-danger fw-bold">
                                    {{calculateDiscountedPrice2(selectedProduct, type.price) | currency}}
                                </span>
                            </span>
                            <span class="text-danger ms-2" *ngIf="!selectedProduct.offer">{{type.price | currency}}</span>
                        </span>
                        <input type="radio" 
                            name="size" 
                            class="form-check-input" 
                            [value]="type.id"
                            [(ngModel)]="selectedSize">
                    </label>
                </div>
            </div>
            <div class="col-lg-6 mt-3">
                <!-- Free Sides Section -->
                <div class="list-group extraDiv h-100 mb-4" *ngIf="selectedProduct.free_side > 0 && selectedProduct.sideproducts?.length > 0">
                    <h5 class="fw-bold mb-1">
                        {{selectedProduct.sides_name}}
                        <small class="text-muted">(Choose {{selectedProduct.free_side}})</small>
                        <span *ngIf="selectedFreeSides.length >= selectedProduct.free_side" class="text-danger ms-2">
                            (Maximum {{selectedProduct.free_side}} free sides reached)
                        </span>
                    </h5>
                    <label class="list-group-item d-flex justify-content-between align-items-center"
                        *ngFor="let side of selectedProduct.sideproducts">
                        <span>{{side.name}} - ${{side.price}}</span>
                        <input type="checkbox" 
                            class="form-check-input" 
                            [checked]="isSideSelected(side.id)"
                            (change)="toggleFreeSide(side)"
                            [disabled]="!isSideSelected(side.id) && selectedFreeSides.length >= selectedProduct.free_side">
                    </label>
                </div>
            </div>
            <div class="col-lg-12 mt-3">
                <!-- Extras with Quantity Control -->
                <div class="list-group extraDiv mb-4 extraDivSection" *ngIf="selectedProduct.extraproducts?.length">
                    <h5 class="fw-bold mb-1">Extras</h5>
                    <div class="list-group-item" *ngFor="let extra of selectedProduct.extraproducts">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>{{extra.name}} - {{extra.price | currency}}</span>
                            <div class="d-flex align-items-center">
                                <button class="btn quantity-btn" 
                                    style="border: 0;"
                                    (click)="decreaseExtraQuantity(extra)"
                                    [disabled]="getExtraQuantity(extra.id) === 0">
                                    <i class="bx bx-minus"></i>
                                </button>
                                <span class="mx-2" style="min-width: 30px; text-align: center;">
                                    {{getExtraQuantity(extra.id)}}
                                </span>
                                <button class="btn quantity-btn" 
                                        (click)="increaseExtraQuantity(extra)">
                                    <i class="bx bx-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
            <div class="col-lg-4">
                <div class="text-center m-4 py-3 ">
                    <h5 class="fw-bold mb-0 text-white">
                        <img src="../../../../assets/img/home2/total.png" width="30" height="30" alt="Total"> Total
                    </h5>
                    <div class="mt-2">
                        <span *ngIf="selectedProduct.offer" class="text-white text-decoration-line-through me-2">
                            {{calculateOriginalTotal() | currency}}
                        </span>
                        <h4 class="mb-0 d-inline-block text-white" style="font-weight: 600;" [class.text-danger]="selectedProduct.offer">
                            {{calculateTotal() | currency}}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
            <div class="col-12 quantityImageSection text-center">
                <div class="d-flex align-items-center mt-1 mb-3 justify-content-center">
                    <button class="btn quantity-btn" (click)="decreaseQuantity()">
                        <i class="bx bx-minus"></i>
                    </button>
                    
                    <input type="number" 
                        class="form-control quantity-input text-center mx-2" 
                        [(ngModel)]="quantity" 
                        min="1" 
                        max="99" 
                        style="width: 60px;">
                    
                    <button class="btn quantity-btn" (click)="increaseQuantity()">
                        <i class="bx bx-plus"></i>
                    </button>
                </div>
                <button class="btn btn-primary add-to-cart-btn" (click)="addToCart()">
                    <i class="bx bx-cart me-2"></i> Add To Cart
                </button>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>